type RafThrottled<T extends unknown[]> = ((...args: T) => void) & {
  cancel: () => void
}

// Collapses a burst of calls (e.g. mousemove) to at most one per animation
// frame, always invoking with the latest arguments. `cancel()` drops any
// pending frame — call it before removing the event listener.
export const rafThrottle = <T extends unknown[]>(
  callback: (...args: T) => void,
): RafThrottled<T> => {
  let frameId: number | null = null
  let lastArgs: T

  const throttled = (...args: T) => {
    lastArgs = args
    if (frameId !== null) {
      return
    }
    frameId = requestAnimationFrame(() => {
      frameId = null
      callback(...lastArgs)
    })
  }

  throttled.cancel = () => {
    if (frameId !== null) {
      cancelAnimationFrame(frameId)
      frameId = null
    }
  }

  return throttled
}
